import type { ResourceProps } from "@refinedev/core";
import {
  DashboardOutlined,
  TeamOutlined,
  CreditCardOutlined,
  FileTextOutlined,
  ApartmentOutlined,
  DollarOutlined,
  ExperimentOutlined,
  FlagOutlined,
  HeartOutlined,
  AuditOutlined,
} from "@ant-design/icons";

/**
 * Definição central dos resources do Refine.
 *
 * O `name` vira o segmento de rota no dataProvider simple-rest, ou seja
 * GET `${VITE_API_URL}/admin/<name>`. Os `meta.label`/`icon` controlam o menu.
 *
 * Resources read-only (ai-metrics, corrections, health) só declaram `list`.
 * Os agrupamentos via `meta.parent` organizam o sider em seções.
 */
export const resources: ResourceProps[] = [
  // ──────────────────────────── Visão geral ───────────────────────────
  // Dashboard inicial do app (rota "/"). `list: "/"` faz o item de menu
  // apontar para a home e ficar selecionado quando a rota é a raiz.
  {
    name: "dashboard",
    list: "/",
    meta: { label: "Visão geral", icon: <DashboardOutlined /> },
  },

  // ───────────────────────────── Operação ─────────────────────────────
  { name: "operacao", meta: { label: "Operação", icon: <TeamOutlined /> } },
  {
    name: "users",
    list: "/users",
    show: "/users/show/:id",
    edit: "/users/edit/:id",
    meta: { label: "Usuários", parent: "operacao", icon: <TeamOutlined /> },
  },
  {
    name: "plans",
    list: "/plans",
    show: "/plans/show/:id",
    meta: {
      label: "Planos & Billing",
      parent: "operacao",
      icon: <CreditCardOutlined />,
    },
  },
  {
    name: "entries",
    list: "/entries",
    show: "/entries/show/:id",
    meta: {
      label: "Entries (moderação)",
      parent: "operacao",
      icon: <FileTextOutlined />,
    },
  },
  {
    name: "brains",
    list: "/brains",
    show: "/brains/show/:id",
    meta: {
      label: "Brains (moderação)",
      parent: "operacao",
      icon: <ApartmentOutlined />,
    },
  },

  // ──────────────────────────────── IA ────────────────────────────────
  { name: "ia", meta: { label: "IA", icon: <ExperimentOutlined /> } },
  {
    name: "ai-metrics",
    list: "/ai-metrics",
    meta: { label: "Uso & Custo", parent: "ia", icon: <DollarOutlined /> },
  },
  {
    name: "corrections",
    list: "/corrections",
    meta: {
      label: "Qualidade da classificação",
      parent: "ia",
      icon: <ExperimentOutlined />,
    },
  },

  // ────────────────────────────── Sistema ─────────────────────────────
  { name: "sistema", meta: { label: "Sistema", icon: <FlagOutlined /> } },
  {
    name: "feature-flags",
    list: "/feature-flags",
    edit: "/feature-flags/edit/:id",
    meta: { label: "Feature flags", parent: "sistema", icon: <FlagOutlined /> },
  },
  {
    name: "audit-log",
    list: "/audit-log",
    meta: { label: "Log de auditoria", parent: "sistema", icon: <AuditOutlined /> },
  },
  {
    name: "health",
    list: "/health",
    meta: { label: "Saúde do sistema", parent: "sistema", icon: <HeartOutlined /> },
  },
];
